<svg 
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.55188 0.576172H21.3693C22.663 0.576172 23.7214 1.47617 23.7214 2.57617V14.5762C23.7214 15.6762 22.663 16.5762 21.3693 16.5762H2.55188C1.25818 16.5762 0.199707 15.6762 0.199707 14.5762L0.211468 2.57617C0.211468 1.47617 1.25818 0.576172 2.55188 0.576172ZM11.9606 9.57617L21.3693 4.57617V2.57617L11.9606 7.57617L2.55188 2.57617V4.57617L11.9606 9.57617Z" fill="#CAD1E1"/>
</svg>
